// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomPin = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '12',
      height: '12',
      viewBox: '0 0 12 12',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.5068 4.77962C10.6244 4.89731 10.8151 4.89735 10.9328 4.77971L10.9843 4.72824C11.1308 4.58169 11.1302 4.34391 10.9829 4.1981L7.76617 1.01351C7.62057 0.86936 7.38455 0.87432 7.24513 1.02446L7.20838 1.06403C7.09612 1.18493 7.0996 1.37297 7.21626 1.48963C7.34315 1.61653 7.33448 1.82479 7.19746 1.94069L3.47663 5.08811C3.28775 5.24789 3.00794 5.23627 2.83296 5.06139L2.76047 4.98894C2.61573 4.84429 2.38143 4.84345 2.23566 4.98705C2.0885 5.13203 2.0874 5.36907 2.23322 5.51541L3.56164 6.84852C3.85366 7.14157 3.85323 7.61575 3.56067 7.90827L1.01441 10.4542C0.868278 10.6004 0.867978 10.8372 1.01374 10.9837C1.16 11.1307 1.39781 11.131 1.54445 10.9844L4.09107 8.43831C4.38357 8.14587 4.85761 8.14544 5.15064 8.43734L6.48461 9.76614C6.63094 9.9119 6.86794 9.91079 7.01289 9.76365C7.15651 9.61786 7.15563 9.38351 7.01092 9.2388L6.93846 9.16633C6.76348 8.99135 6.75184 8.71145 6.91171 8.52255L10.0639 4.79793C10.1777 4.6634 10.3822 4.65495 10.5068 4.77962Z',
      fill: 'black',
    }),
  );

export { IconCustomPin };
